module.exports = __webpack_public_path__ + "media/images/indicators/spei-a5a6ba0c851ef38f176762b055d45826.png";